
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"6 4 21 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.638 7.114h15.367c1.212 0 2.195.983 2.195 2.195v15.367a2.195 2.195 0 01-2.195 2.195H8.638a2.195 2.195 0 01-2.195-2.195V9.309c0-1.212.982-2.195 2.195-2.195zM20.71 4.918v4.39M11.932 4.918v4.39M6.443 13.699H26.2","stroke":"currentColor","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M12.05 18.928h-.84a.74.74 0 01-.74-.74v-.838a.74.74 0 01.74-.74h.84a.74.74 0 01.74.74v.839a.74.74 0 01-.74.739zM21.57 18.928h-.84a.74.74 0 01-.74-.74v-.838a.74.74 0 01.74-.74h.84a.74.74 0 01.74.74v.839a.74.74 0 01-.74.739zM16.811 18.928h-.839a.74.74 0 01-.74-.74v-.838a.74.74 0 01.74-.74h.84a.74.74 0 01.74.74v.839a.74.74 0 01-.74.739zM11.98 23.421h-.84a.74.74 0 01-.74-.74v-.839a.74.74 0 01.74-.74h.84a.74.74 0 01.74.74v.84a.74.74 0 01-.74.74zM21.5 23.421h-.838a.74.74 0 01-.74-.74v-.839a.74.74 0 01.74-.74h.839a.74.74 0 01.74.74v.84a.74.74 0 01-.74.74zM16.741 23.421h-.839a.74.74 0 01-.74-.74v-.839a.74.74 0 01.74-.74h.84a.74.74 0 01.74.74v.84a.742.742 0 01-.74.74z","fill":"currentColor"}})])
          )
        }
      }
    